export default "__VITE_ASSET__BOW4yUw6__"